module.exports = __webpack_public_path__ + "img/banner-02.b43a24a5.jpg";